/**
 * Sentinel stored as the first element of a workflow stage's `allowedAssigneeRoles`.
 * Disputes reaching such a level are assigned to the credit controller recorded
 * against the customer account, resolved by the backend at creation/escalation time.
 */
export const CREDIT_CONTROLLER_ASSIGNEE = 'CREDIT_CONTROLLER' as const;

export const CREDIT_CONTROLLER_ASSIGNEE_LABEL = 'Assigned Credit Controller';

export const UNASSIGNED_ASSIGNEE = 'Unassigned' as const;
